import React, { useState, useEffect } from "react";
import Entry from "./Entry";
import { render } from "react-dom";
import updateSchedule from "./UpdateData";

var url = new URL(window.location.href);
var busStop = url.searchParams.get("busStop");
if (busStop === null) {
  busStop = "09037";
}

class Form extends React.Component {
  constructor() {
    super();
    this.state = { value: "" };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    console.log(this.state.value);
    console.log(window.location.origin);
    window.location.href =
      window.location.origin + "?busStop=" + this.state.value;
    event.preventDefault();
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          className="bg-white max-w-md focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
          type="text"
          value={this.state.value}
          id="busStopNumber"
          placeholder="Bus Stop Number"
          onChange={this.handleChange}
        ></input>
      </form>
    );
  }
}
const App = () => {
  const [data, setData] = useState([]);
  //updateSchedule().then((firstData) => setData(firstData)); // get the first

  useEffect(() => {
    updateSchedule(busStop).then((data) => {
      data.sort((a, b) => {
        return a.Time - b.Time;
      });
      console.log(data);
      setData(data);
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetch("https://us-central1-bus-project-260612.cloudfunctions.net/bus-app-update/api/" + busStop, {
        mode: "cors",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          data.sort((a, b) => {
            return a.Time - b.Time;
          });

          setData(data || []);
        })
        .catch((error) => console.error(error));
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col bg-gray-200 content-center items-center p-5">
      <h1 className="font-mono text-xl">Bus Stop : {busStop}</h1>
      <Form />

      {data.map((item) => (
        <Entry
          serviceno={item.ServiceNo}
          time={item.TimeToArrive}
          load={item.Load}
          type={item.Type}
        />
      ))}
    </div>
  );
};
render(<App />, document.getElementById("root"));
